import React from 'react';
import PaymentGeneratedByQrVersionSelector from './PaymentGeneratedByQrVersionSelector';


function PaymentGeneratedByQRPage() {
  return <><PaymentGeneratedByQrVersionSelector/></>;
}

export default PaymentGeneratedByQRPage;
